// Preset search suggestions; each gets a statically generated results page
// at /search/<slug> (see pages/search/[term].js).
export const SEARCH_SUGGESTIONS = [
  { label: 'Approach', slug: 'approach' },
  { label: 'Faculty and Staff', slug: 'faculty-and-staff' },
  { label: 'Crisis intervention', slug: 'crisis-intervention' },
];
